import { HaNViewStoreContext } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";

import { useRoomsModel } from "../../rooms/useRoomsModel";
import { HaNDetailsContext } from "../../shell/regions/HaNDetailsContext";
import { useHaNLayoutMode } from "../../state/layout/useHaNLayoutMode";

/** Closes a room's details once it's booked. On phones the carousel moves on to the next room on the rooms tab. */
export const useCompleteRoomBooking = () => {
  const { tab } = useRequiredContext(HaNDetailsContext);
  const viewStore = useRequiredContext(HaNViewStoreContext);
  const { rooms } = useRoomsModel();
  const layoutMode = useHaNLayoutMode();

  // The rooms as they were listed when booking started, so the booked room is still among them
  const roomIds = tab === "rooms" ? rooms.map(room => room.id) : [];

  return (bookedRoomId: string) => {
    viewStore.completeBooking(tab, { roomIds, bookedRoomId, isPhoneLayout: layoutMode === "mobile" });
  };
};
